var React = require('react');

function Laugh (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M248,8C111,8,0,119,0,256S111,504,248,504,496,393,496,256,385,8,248,8Zm80,152a32,32,0,1,1-32,32A32,32,0,0,1,328,160Zm-160,0a32,32,0,1,1-32,32A32,32,0,0,1,168,160ZM398.9,306A144.12,144.12,0,0,1,256,432H240A144.12,144.12,0,0,1,97.1,306a16.06,16.06,0,0,1,14-17.88A15,15,0,0,1,113,288H383a16,16,0,0,1,16,16A16.64,16.64,0,0,1,398.9,306Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M328,160a32,32,0,1,0,32,32A32,32,0,0,0,328,160Zm-160,0a32,32,0,1,0,32,32A32,32,0,0,0,168,160Z","className":"fa-primary","key":2})]);
}

Laugh.defaultProps = {"viewBox":"0 0 496 512","className":"icon"};

module.exports = Laugh;

Laugh.default = Laugh;
